import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Render outside the sticky/backdrop-filtered header so the viewport owns sizing.
export default function MobileDrawer({ title, onClose, children, variant, side = "left" }) {
  const ref = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const dialog = ref.current;
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    const panel = dialog.querySelector('.mobile-drawer-panel');
    const animation = side === 'right' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
      ? panel.animate?.([
          { transform: 'translateX(100%)' },
          { transform: 'translateX(0)' },
        ], { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' })
      : null;
    return () => {
      animation?.cancel();
      dialog.close();
      document.body.style.overflow = overflow;
      previousFocus?.focus?.({ preventScroll: true });
    };
  }, [side]);
  return createPortal(<dialog ref={ref} aria-label={title} className={`mobile-drawer${side === "right" ? " mobile-drawer-right" : ""}${['categories', 'filters'].includes(variant) ? ` category-drawer${variant === 'filters' ? ' filter-drawer' : ''}` : ''}`}
    onCancel={event => { event.preventDefault(); close.current(); }}
    onClick={event => { if (event.target === ref.current) close.current(); }}>
    <aside className="mobile-drawer-panel">
      <div className="mobile-drawer-heading mb-4 flex items-center justify-between gap-3">
        <h2 className="m-0 text-lg font-semibold">{title}</h2>
        <button type="button" aria-label={`Close ${title}`} onClick={onClose}
          className="min-h-[44px] min-w-[44px] rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-sky-50 hover:text-sky-700" ><span aria-hidden="true">{'\u00d7'}</span></button>
      </div>
      {children}
    </aside>
  </dialog>, document.body);
}
